class HeroVideoComponent extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('[data-hero-video]');
    this.content = this.querySelector('[data-hero-content]');

    if (this.video) {
      const tryPlay = () => {
        const playPromise = this.video.play();
        if (playPromise?.catch) {
          playPromise.catch(() => {});
        }
      };

      if (this.video.readyState >= 2) {
        tryPlay();
      } else {
        this.video.addEventListener('loadeddata', tryPlay, { once: true });
      }
    }

    if (!this.content) return;

    const reveal = () => this.content.classList.add('is-in');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.35 }
      );
      observer.observe(this.content);
    } else {
      reveal();
    }
  }
}

if (!customElements.get('hero-video-component')) {
  customElements.define('hero-video-component', HeroVideoComponent);
}
